module.exports = __webpack_public_path__ + "img/xiao1.fb11cf9b.png";